import {
    HiverAxios
} from 'h-commons';
import {
    GET_INVOICE_DETAIL_DONE,
    GET_INVOICE_DETAIL_FAILED,
    GET_ACCOUNT_DETAILS_INIT,
    RESET_INVOICE_PAYMENT_ERROR
} from './types';

export const getInvoiceDetail = (id) => (dispatch) => {
    dispatch({ type: GET_ACCOUNT_DETAILS_INIT });
    HiverAxios({
        url: `/api/account/payment/invoice/${id}`,
        type: 'GET',
        callback: resp => {
            if (resp.data && resp.data.success) {
                dispatch({ type: GET_INVOICE_DETAIL_DONE, payload: resp.data.data });
            } else {
                dispatch({ type: GET_INVOICE_DETAIL_FAILED, payload: id });
            }
            dispatch({ type: RESET_INVOICE_PAYMENT_ERROR });
        },
        onfail: () => {
            dispatch({ type: GET_INVOICE_DETAIL_FAILED, payload: id });
        }
    })
}